import { initialState } from "../clients.slice";

const resetClients = () => {
    return initialState;
}

export default resetClients;